exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-cf8d5bb4]{margin-top:20px;padding-right:20px}.addhead ul[data-v-cf8d5bb4]{padding-right:20px}.addhead ul li[data-v-cf8d5bb4]{width:100%}.avatar-uploader .el-upload[data-v-cf8d5bb4]{border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-cf8d5bb4]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-cf8d5bb4]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center;border:1px dashed #d9d9d9}.avatar[data-v-cf8d5bb4]{width:178px;height:178px;display:block}\n", ""]);

// exports
